import * as React from 'react'

import ImportOptions from './ImportOptions'
import Box from '@mui/material/Box'


export default function Imports(props) {
    return (
        <>
            <Box
                component="main"
                sx={{
                    backgroundColor: theme => theme.palette.background.default,
                    flexGrow: 1,
                    height: '100vh',
                    overflow: 'auto',
                    marginLeft: 4,
                }}
            >
                <ImportOptions {...props} />
            </Box>
        </>
    )
}
